import React from 'react'

import moment from 'moment'

import * as Display from 'app/components/display/display'
import * as Text from 'app/components/display/text/text_component'
import {
  disclosureVersionedQuestions,
  getDisclosureMissingVersion,
} from 'app/pages/teams/onlist/components/Disclosures/questions'
import * as helpers from 'app/sm/helpers'
import * as dateTimeHelpers from 'app/utils/datetime/helpers'
import * as onlistHelpers from 'app/utils/onlist/helpers'
import { DISCLOSURE_QUESTIONS_DISPLAY } from 'app/utils/text/helpers'

const convertToReadableDate = (date) =>
  moment(date).format(dateTimeHelpers.DATE_DAY_SHORT_STRING_MONTH_YEAR)

// Check if this is a legacy disclosure (NSW-style) with general PDF attachments
// Legacy disclosures (version 0) should show "Please click to download" instead of individual questions
const isLegacyDisclosureWithAttachments = (version, hasAttachments) => {
  const MISSING_VERSION = getDisclosureMissingVersion()
  return version === MISSING_VERSION && hasAttachments
}

class DisclosureQuestionsDisplay extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      disclosureContainerOpened: false,
      showDisclosures: false,
    }
  }
  componentDidMount() {
    const { openDisclosuresModal = false } = this.props
    if (openDisclosuresModal) {
      this.setState({
        showDisclosures: true,
      })
    }
  }

  renderAttachments = (disclosureAttachments) => {
    let attachmentListedEl = []
    disclosureAttachments.forEach((attachment, index) =>
      attachmentListedEl.push(
        <li>
          <a target="_blank" href={attachment.url} rel="noreferrer">
            {`Disclosures ${index + 1}`}
          </a>
        </li>,
      ),
    )

    return <ul>{attachmentListedEl}</ul>
  }

  getModalBodyStyles = () => ({
    maxHeight: '70vh',
    overflowY: 'auto',
    paddingBottom: '20px',
  })

  render() {
    const {
      propertyDisclosure = {},
      hasPropertyDisclosure = false,
      showDisclosureLink = true,
      autoresponderAttachments = [],
    } = this.props
    const { showDisclosures } = this.state
    const {
      compliesWithMinimumStandards = '',
      isBeingSold = '',
      dateOfDrugUsage = '',
      dateOfElectricityCheck = '',
      dateOfGasCheck = '',
      dateOfHomicide = '',
      dateOfPoolCheck = '',
      dateOfRepairNotice = '',
      embeddedNetworkAbn = '',
      embeddedNetworkName = '',
      embeddedNetworkPhone = '',
      embeddedNetworkPricing = '',
      hasAsbestos = '',
      hasEmbeddedNetwork = '',
      hasHomicide = '',
      isAffectedWithRelevantAuthorities = '',
      isRegisteredPlace = '',
      embeddedNetworkWebsite = '',
      // V3 fields - using snake_case to match API response
      has_engaged_agent_to_sell = '',
      has_contract_of_sale_prepared = '',
      has_mortgagee_action = '',
      mortgagee_has_commenced_proceedings = '',
      is_property_owner = '',
      has_mould_damp_repair_notice_3yr = '',
      has_outstanding_safety_recommendations = '',
      outstanding_safety_recommendations_desc = '',
      is_heritage_listed = '',
      has_drug_usage_5yr = '',
      has_defect_safety_concern_notice = '',
      defect_safety_concern_notice_desc = '',
      has_domestic_building_dispute = '',
      has_owners_corporation_dispute = '',
      has_owners_corporation_rules = '',
      disclosureAttachments,
      version = getDisclosureMissingVersion(),
    } = propertyDisclosure || {}

    const showAttachments =
      disclosureAttachments && disclosureAttachments.length > 0

    const {
      consumer_renting_guide,
      property_disclosures,
      statement_of_information,
    } = DISCLOSURE_QUESTIONS_DISPLAY

    return (
      <div>
        Please review information and ways to submit your application:{' '}
        {autoresponderAttachments.map((attachment, index) => (
          <a
            key={attachment.id}
            href={attachment.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {`${attachment.displayName}, `}
          </a>
        ))}
        <a
          href={helpers.CONSUMER_GUIDE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {consumer_renting_guide}
        </a>
        {showDisclosureLink && (
          <span
            onClick={() => {
              this.setState({ showDisclosures: !showDisclosures })
            }}
            className="blue-link-style htu"
          >
            , {property_disclosures}
          </span>
        )}{' '}
        and the{' '}
        <a
          href="https://help.snug.com/hc/en-us/articles/360000771916"
          target="_blank"
          rel="noopener noreferrer"
        >
          {statement_of_information}
        </a>
        {showDisclosures && (
          <Display.Modal
            toggleModal={() =>
              this.setState({ showDisclosures: !showDisclosures })
            }
            title="Disclosure Information"
            hideButtonSection={true}
          >
            {hasPropertyDisclosure ? (
              <div style={this.getModalBodyStyles()}>
                {isLegacyDisclosureWithAttachments(version, showAttachments) ? (
                  <>
                    <Text.Strong text="Please click to download the disclosures for this property:" />
                    {this.renderAttachments(disclosureAttachments)}
                  </>
                ) : (
                  <>
                    {hasEmbeddedNetwork && (
                      <Text.Strong text="Embedded Network" />
                    )}
                    {hasEmbeddedNetwork && (
                      <ul>
                        {disclosureVersionedQuestions.embeddedNetworkName.versions.includes(
                          version,
                        ) && (
                          <li>
                            {
                              disclosureVersionedQuestions.embeddedNetworkName
                                .text
                            }{' '}
                            {embeddedNetworkName}
                          </li>
                        )}
                        {disclosureVersionedQuestions.embeddedNetworkAbn.versions.includes(
                          version,
                        ) && (
                          <li>
                            {
                              disclosureVersionedQuestions.embeddedNetworkAbn
                                .text
                            }{' '}
                            {embeddedNetworkAbn}
                          </li>
                        )}
                        {disclosureVersionedQuestions.embeddedNetworkPhone.versions.includes(
                          version,
                        ) && (
                          <li>
                            {
                              disclosureVersionedQuestions.embeddedNetworkPhone
                                .text
                            }{' '}
                            {embeddedNetworkPhone}
                          </li>
                        )}
                        {disclosureVersionedQuestions.embeddedNetworkPricing.versions.includes(
                          version,
                        ) && (
                          <li>
                            {
                              disclosureVersionedQuestions
                                .embeddedNetworkPricing.text
                            }{' '}
                            {embeddedNetworkPricing}
                          </li>
                        )}
                        {disclosureVersionedQuestions.embeddedNetworkWebsite.versions.includes(
                          version,
                        ) && (
                          <li>
                            {
                              disclosureVersionedQuestions
                                .embeddedNetworkWebsite.text
                            }{' '}
                            {embeddedNetworkWebsite}
                          </li>
                        )}
                      </ul>
                    )}
                    <ul>
                      {disclosureVersionedQuestions.isBeingSold.versions.includes(
                        version,
                      ) && (
                        <li>
                          {disclosureVersionedQuestions.isBeingSold
                            .getTextForVersion
                            ? disclosureVersionedQuestions.isBeingSold.getTextForVersion(
                                version,
                              )
                            : disclosureVersionedQuestions.isBeingSold
                                .text}{' '}
                          {onlistHelpers.convertBoolToYesOrNo(isBeingSold)}
                        </li>
                      )}
                      {isBeingSold &&
                        disclosureVersionedQuestions.hasEngagedAgentToSell.versions.includes(
                          version,
                        ) && (
                          <li>
                            {
                              disclosureVersionedQuestions.hasEngagedAgentToSell
                                .text
                            }{' '}
                            {onlistHelpers.convertBoolToYesOrNo(
                              has_engaged_agent_to_sell,
                            )}
                          </li>
                        )}
                      {isBeingSold &&
                        disclosureVersionedQuestions.hasContractOfSalePrepared.versions.includes(
                          version,
                        ) && (
                          <li>
                            {
                              disclosureVersionedQuestions
                                .hasContractOfSalePrepared.text
                            }{' '}
                            {onlistHelpers.convertBoolToYesOrNo(
                              has_contract_of_sale_prepared,
                            )}
                          </li>
                        )}
                      {disclosureVersionedQuestions.hasMortgageeAction.versions.includes(
                        version,
                      ) && (
                        <li>
                          {disclosureVersionedQuestions.hasMortgageeAction.text}{' '}
                          {onlistHelpers.convertBoolToYesOrNo(
                            has_mortgagee_action,
                          )}
                        </li>
                      )}
                      {has_mortgagee_action &&
                        disclosureVersionedQuestions.mortgageeHasCommencedProceedings.versions.includes(
                          version,
                        ) && (
                          <li>
                            {
                              disclosureVersionedQuestions
                                .mortgageeHasCommencedProceedings.text
                            }{' '}
                            {onlistHelpers.convertBoolToYesOrNo(
                              mortgagee_has_commenced_proceedings,
                            )}
                          </li>
                        )}
                      {disclosureVersionedQuestions.isPropertyOwner.versions.includes(
                        version,
                      ) && (
                        <li>
                          {disclosureVersionedQuestions.isPropertyOwner.text}{' '}
                          {onlistHelpers.convertBoolToYesOrNo(
                            is_property_owner,
                          )}
                        </li>
                      )}
                      {disclosureVersionedQuestions.hasHomicide.versions.includes(
                        version,
                      ) && (
                        <li>
                          {disclosureVersionedQuestions.hasHomicide
                            .getTextForVersion
                            ? disclosureVersionedQuestions.hasHomicide.getTextForVersion(
                                version,
                              )
                            : disclosureVersionedQuestions.hasHomicide
                                .text}{' '}
                          {onlistHelpers.convertBoolToYesOrNo(hasHomicide)}
                        </li>
                      )}
                      {hasHomicide &&
                        disclosureVersionedQuestions.dateOfHomicide.versions.includes(
                          version,
                        ) && (
                          <li>
                            {disclosureVersionedQuestions.dateOfHomicide.text}{' '}
                            {convertToReadableDate(dateOfHomicide)}
                          </li>
                        )}
                      {disclosureVersionedQuestions.isRegisteredPlace.versions.includes(
                        version,
                      ) && (
                        <li>
                          {disclosureVersionedQuestions.isRegisteredPlace.text}{' '}
                          {onlistHelpers.convertBoolToYesOrNo(
                            isRegisteredPlace,
                          )}
                        </li>
                      )}
                      {disclosureVersionedQuestions.compliesWithMinimumStandards.versions.includes(
                        version,
                      ) && (
                        <li>
                          {
                            disclosureVersionedQuestions
                              .compliesWithMinimumStandards.text
                          }{' '}
                          {onlistHelpers.convertBoolToYesOrNo(
                            compliesWithMinimumStandards,
                          )}
                        </li>
                      )}
                      {dateOfRepairNotice &&
                        disclosureVersionedQuestions.dateOfRepairNotice.versions.includes(
                          version,
                        ) && (
                          <li>
                            {
                              disclosureVersionedQuestions.dateOfRepairNotice
                                .text
                            }{' '}
                            {convertToReadableDate(dateOfRepairNotice)}
                          </li>
                        )}
                      {disclosureVersionedQuestions.hasMouldDampRepairNotice3Yr.versions.includes(
                        version,
                      ) && (
                        <li>
                          {
                            disclosureVersionedQuestions
                              .hasMouldDampRepairNotice3Yr.text
                          }{' '}
                          {onlistHelpers.convertBoolToYesOrNo(
                            has_mould_damp_repair_notice_3yr,
                          )}
                        </li>
                      )}
                      {dateOfGasCheck &&
                        disclosureVersionedQuestions.dateOfGasCheck.versions.includes(
                          version,
                        ) && (
                          <li>
                            {disclosureVersionedQuestions.dateOfGasCheck.text}{' '}
                            {convertToReadableDate(dateOfGasCheck)}
                          </li>
                        )}
                      {dateOfElectricityCheck &&
                        disclosureVersionedQuestions.dateOfElectricityCheck.versions.includes(
                          version,
                        ) && (
                          <li>
                            {
                              disclosureVersionedQuestions
                                .dateOfElectricityCheck.text
                            }{' '}
                            {convertToReadableDate(dateOfElectricityCheck)}
                          </li>
                        )}
                      {disclosureVersionedQuestions.hasOutstandingSafetyRecommendations.versions.includes(
                        version,
                      ) && (
                        <li>
                          {
                            disclosureVersionedQuestions
                              .hasOutstandingSafetyRecommendations.text
                          }{' '}
                          {onlistHelpers.convertBoolToYesOrNo(
                            has_outstanding_safety_recommendations,
                          )}
                        </li>
                      )}
                      {has_outstanding_safety_recommendations &&
                        outstanding_safety_recommendations_desc &&
                        disclosureVersionedQuestions.outstandingSafetyRecommendationsDesc.versions.includes(
                          version,
                        ) && (
                          <li>
                            {
                              disclosureVersionedQuestions
                                .outstandingSafetyRecommendationsDesc.text
                            }{' '}
                            {outstanding_safety_recommendations_desc}
                          </li>
                        )}
                      {dateOfPoolCheck &&
                        disclosureVersionedQuestions.dateOfPoolCheck.versions.includes(
                          version,
                        ) && (
                          <li>
                            {disclosureVersionedQuestions.dateOfPoolCheck.text}{' '}
                            {convertToReadableDate(dateOfPoolCheck)}
                          </li>
                        )}
                      {disclosureVersionedQuestions.isHeritageListed.versions.includes(
                        version,
                      ) && (
                        <li>
                          {disclosureVersionedQuestions.isHeritageListed.text}{' '}
                          {onlistHelpers.convertBoolToYesOrNo(
                            is_heritage_listed,
                          )}
                        </li>
                      )}
                      {dateOfDrugUsage &&
                        disclosureVersionedQuestions.dateOfDrugUsage.versions.includes(
                          version,
                        ) && (
                          <li>
                            {disclosureVersionedQuestions.dateOfDrugUsage.text}{' '}
                            {convertToReadableDate(dateOfDrugUsage)}
                          </li>
                        )}
                      {disclosureVersionedQuestions.hasDrugUsage5Yr.versions.includes(
                        version,
                      ) && (
                        <li>
                          {disclosureVersionedQuestions.hasDrugUsage5Yr.text}{' '}
                          {onlistHelpers.convertBoolToYesOrNo(
                            has_drug_usage_5yr,
                          )}
                        </li>
                      )}
                      {disclosureVersionedQuestions.hasAsbestos.versions.includes(
                        version,
                      ) && (
                        <li>
                          {disclosureVersionedQuestions.hasAsbestos.text}{' '}
                          {onlistHelpers.convertBoolToYesOrNo(hasAsbestos)}
                        </li>
                      )}
                      {disclosureVersionedQuestions.hasDefectSafetyConcernNotice.versions.includes(
                        version,
                      ) && (
                        <li>
                          {
                            disclosureVersionedQuestions
                              .hasDefectSafetyConcernNotice.text
                          }{' '}
                          {onlistHelpers.convertBoolToYesOrNo(
                            has_defect_safety_concern_notice,
                          )}
                        </li>
                      )}
                      {has_defect_safety_concern_notice &&
                        defect_safety_concern_notice_desc &&
                        disclosureVersionedQuestions.defectSafetyConcernNoticeDesc.versions.includes(
                          version,
                        ) && (
                          <li>
                            {
                              disclosureVersionedQuestions
                                .defectSafetyConcernNoticeDesc.text
                            }{' '}
                            {defect_safety_concern_notice_desc}
                          </li>
                        )}
                      {disclosureVersionedQuestions.hasDomesticBuildingDispute.versions.includes(
                        version,
                      ) && (
                        <li>
                          {
                            disclosureVersionedQuestions
                              .hasDomesticBuildingDispute.text
                          }{' '}
                          {onlistHelpers.convertBoolToYesOrNo(
                            has_domestic_building_dispute,
                          )}
                        </li>
                      )}
                      {disclosureVersionedQuestions.hasOwnersCorporationDispute.versions.includes(
                        version,
                      ) && (
                        <li>
                          {
                            disclosureVersionedQuestions
                              .hasOwnersCorporationDispute.text
                          }{' '}
                          {onlistHelpers.convertBoolToYesOrNo(
                            has_owners_corporation_dispute,
                          )}
                        </li>
                      )}
                      {disclosureVersionedQuestions.hasOwnersCorporationRules.versions.includes(
                        version,
                      ) && (
                        <li>
                          {
                            disclosureVersionedQuestions
                              .hasOwnersCorporationRules.text
                          }{' '}
                          {onlistHelpers.convertBoolToYesOrNo(
                            has_owners_corporation_rules,
                          )}
                          {has_owners_corporation_rules &&
                            showAttachments &&
                            disclosureAttachments.length > 0 && (
                              <>
                                {' '}
                                {disclosureAttachments.map(
                                  (attachment, index) => (
                                    <span key={attachment.guid || index}>
                                      <a
                                        target="_blank"
                                        href={attachment.url}
                                        rel="noreferrer"
                                      >
                                        Download
                                      </a>
                                      {index <
                                        disclosureAttachments.length - 1 &&
                                        ', '}
                                    </span>
                                  ),
                                )}
                              </>
                            )}
                        </li>
                      )}
                      {disclosureVersionedQuestions.isAffectedWithRelevantAuthorities.versions.includes(
                        version,
                      ) && (
                        <li>
                          {
                            disclosureVersionedQuestions
                              .isAffectedWithRelevantAuthorities.text
                          }{' '}
                          {onlistHelpers.convertBoolToYesOrNo(
                            isAffectedWithRelevantAuthorities,
                          )}
                        </li>
                      )}
                    </ul>
                  </>
                )}
              </div>
            ) : (
              <div>
                <Text.Strong text="Property Disclosures" />
                <Text.Normal text="There are no disclosures provided for this property" />
              </div>
            )}
          </Display.Modal>
        )}
      </div>
    )
  }
}
export default DisclosureQuestionsDisplay
